module.exports = __webpack_public_path__ + "img/klankenkaart.a5fae21f.png";